import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ServiceCharge } from '../../Models/Models/Charges/ServiceCharge';

declare var IS_RUNNING_IN_APP_POOL;

export class ServiceChargesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, assumedCashHolding: number): Promise<Array<ServiceCharge>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/charge/ServiceCharges/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, assumedCashHolding: assumedCashHolding }

    return AjaxWrapper.get<Array<ServiceCharge>, any>(url, data);
  }
}

